"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var React = require("react");
var styled_components_1 = require("styled-components");
var SituationSelectModal_1 = require("../SituationSelectModal");
var SituationSelectNavigation_1 = require("./SituationSelectNavigator/SituationSelectNavigation");
var titleOf = {
    presentee: "相手:",
    age: "年代:",
    occasion: "目的:"
};
exports.SituationSelectNavigator = function (props) {
    var navigations = [];
    if (props.state > SituationSelectModal_1.ModalState.Age) {
        navigations.push(React.createElement(SituationSelectNavigation_1.SituationSelectNavigation, { key: "presentee", title: titleOf.presentee, option: props.selectedPresentee, subOption: props.selectedAge, onClick: props.onClickPresentee }));
    }
    else if (props.state > SituationSelectModal_1.ModalState.Presentee) {
        navigations.push(React.createElement(SituationSelectNavigation_1.SituationSelectNavigation, { key: "presentee", title: titleOf.presentee, option: props.selectedPresentee, onClick: props.onClickPresentee }));
    }
    if (props.state > SituationSelectModal_1.ModalState.Occasion) {
        navigations.push(React.createElement(SituationSelectNavigation_1.SituationSelectNavigation, { key: "occasion", title: titleOf.occasion, option: props.selectedOccasion, onClick: props.onClickOccasion }));
    }
    if (navigations.length <= 0) {
        navigations.push(React.createElement(NoNavigation, { key: "none" }, "\u306A\u3057"));
    }
    return (React.createElement(Navigator, null,
        React.createElement(NavigationLabel, null, "\u9078\u629E\u6E08"),
        navigations));
};
var Navigator = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 8px;\n  position: absolute;\n  overflow: auto;\n  width: 100%;\n  height: 30px;\n  top: 40px;\n"], ["\n  padding: 0 8px;\n  position: absolute;\n  overflow: auto;\n  width: 100%;\n  height: 30px;\n  top: 40px;\n"])));
var NavigationLabel = styled_components_1["default"].span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0 8px;\n  height: 30px;\n  vertical-align: middle;\n  color: #555;\n  &:not(:last-child) {\n    border-right: solid 1px #aaa;\n  }\n"], ["\n  padding: 0 8px;\n  height: 30px;\n  vertical-align: middle;\n  color: #555;\n  &:not(:last-child) {\n    border-right: solid 1px #aaa;\n  }\n"])));
var NoNavigation = styled_components_1["default"].span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 0 8px;\n  height: 30px;\n  line-height: 30px;\n  vertical-align: middle;\n  color: #aaa;\n"], ["\n  padding: 0 8px;\n  height: 30px;\n  line-height: 30px;\n  vertical-align: middle;\n  color: #aaa;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
